import React, { Component } from 'react';
import './questions.css';

import { Form, Input, Select, Button, } from 'antd';

import infoImage from "../static/info-image.png";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Translate from "../translate/Translate";
import{
    infoList,infoSubmit
  }from '../../modules/questions';

class InfoForm extends Component {
	constructor(props){
		super(props);
		this.state = {
			infoPageData:null,
			loading:false,
      elective1Input: false,
      elective2Input: false,
      elective3Input: false,
		}
    }

    componentDidMount() {
		// console.log(localStorage)
		if (!this.props.infoData) {
			this.getInfo();		
		}
    }
    
    getInfo() {
        this.props.infoList();	
       
	}

    componentWillMount(){
		// console.log(this.props.userProfile)
        if(!this.state.infoPageData){
            this.setState({
                infoPageData:{
                    tc:{
                        info:{
                            title:"個人資料",
                            questions:{
                                school: {
                                    label:<Translate id="info.field1"/>,
                                    data:this.props.userProfile.student.schoolName.name_en,
                                    type:"static"
                                },
                                year: {
                                    label:<Translate id="info.field2"/>,
                                    data:this.props.userProfile.student.year,
                                    type:"static"
                                },
                                form: {
                                    label:<Translate id="info.field3"/>,
                                    data:this.props.userProfile.student.className,
                                    type: "static"
                                },
                                age: {
                                    label: <Translate id="info.field4"/>,
                                    type: "input"
                                },
                                chName: {
                                    label: <Translate id="info.field5"/>,
                                    type: "input"
                                },
                                engName: {
                                    label: <Translate id="info.field6"/>,
                                    type: "input"
                                },
                                classNum: {
                                    label: <Translate id="info.field7"/>,
                                    type: "input"
                                },
                                gender: {
                                	label: <Translate id="info.field12"/>,
                                	data: ["M"],
                                	type: "select"
                                },
                                selectiveSubject1: {
                                    label: <Translate id="info.field8"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                selectiveSubject2: {
                                    data: ["不適用"],
                                    type: "select"
                                },
                                selectiveSubject3: {
                                    data: ["不適用"],
                                    type: "select"
                                },
                                fatherLv:{
                                    label: <Translate id="info.field9"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                motherLv: {
                                    label: <Translate id="info.field10"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                religion: {
                                    label: <Translate id="info.field1"/>,
                                    data: ["不適用"],
                                    type: "select"
                                }
                            }
                        },
                        submit:"下一步"
                    },
                    en:{
                    	info:{
                            title:"Personal Data",
                            questions:{
                                school: {
                                    label:<Translate id="info.field1"/>,
                                    data:this.props.userProfile.student.schoolName.name_en,
                                    type:"static"
                                },
                                year: {
                                    label:<Translate id="info.field2"/>,
                                    data:this.props.userProfile.student.year,
                                    type:"static"
                                },
                                form: {
                                    label:<Translate id="info.field3"/>,
                                    data:this.props.userProfile.student.className,
                                    type: "static"
                                },
                                age: {
                                    label: <Translate id="info.field4"/>,
                                    type: "input"
                                },
                                chName: {
                                    label: <Translate id="info.field5"/>,
                                    type: "input"
                                },
                                engName: {
                                    label: <Translate id="info.field6"/>,
                                    type: "input"
                                },
                                classNum: {
                                    label: <Translate id="info.field7"/>,
                                    type: "input"
                                },
                                gender: {
                                	label: <Translate id="info.field12"/>,
                                	data: ["M"],
                                	type: "select"
                                },
                                selectiveSubject1: {
                                    label: <Translate id="info.field8"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                selectiveSubject2: {
                                    data: ["不適用"],
                                    type: "select"
                                },
                                selectiveSubject3: {
                                    data: ["不適用"],
                                    type: "select"
                                },
                                fatherLv:{
                                    label: <Translate id="info.field9"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                motherLv: {
                                    label: <Translate id="info.field10"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                religion: {
                                    label: <Translate id="info.field1"/>,
                                    data: ["不適用"],
                                    type: "select"
                                }
                            }
                        },
                        submit:"Next"
                    },
                    sc:{
                    	info:{
                            title:"個人資料",
                            questions:{
                                school: {
                                    label:<Translate id="info.field1"/>,
                                    data:this.props.userProfile.student.schoolName.name_en,
                                    type:"static"
                                },
                                year: {
                                    label:<Translate id="info.field2"/>,
                                    data:this.props.userProfile.student.year,
                                    type:"static"
                                },
                                form: {
                                    label:<Translate id="info.field3"/>,
                                    data:this.props.userProfile.student.className,
                                    type: "static"
                                },
                                age: {
                                    label: <Translate id="info.field4"/>,
                                    type: "input"
                                },
                                chName: {
                                    label: <Translate id="info.field5"/>,
                                    type: "input"
                                },
                                engName: {
                                    label: <Translate id="info.field6"/>,
                                    type: "input"
                                },
                                classNum: {
                                    label: <Translate id="info.field7"/>,
                                    type: "input"
                                },
                                gender: {
                                	label: <Translate id="info.field12"/>,
                                	data: ["M"],
                                	type: "select"
                                },
                                selectiveSubject1: {
                                    label: <Translate id="info.field8"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                selectiveSubject2: {
                                    data: ["不適用"],
                                    type: "select"
                                },
                                selectiveSubject3: {
                                    data: ["不適用"],
                                    type: "select"
                                },
                                fatherLv:{
                                    label: <Translate id="info.field9"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                motherLv: {
                                    label: <Translate id="info.field10"/>,
                                    data: ["不適用"],
                                    type: "select"
                                },
                                religion: {
                                    label: <Translate id="info.field1"/>,
                                    data: ["不適用"],
                                    type: "select"
                                }
                            }
                        },
                        submit:"下一步"
                    }
                }
            })
        }
    }

    actFormSubmit= form =>{
		// console.log('Received values of form: ', form);
		this.setState({loading:true});
    form.elective1 = form.elective1 === 'other' && form.elective1input ? form.elective1input : form.elective1;
    form.elective2 = form.elective2 === 'other' && form.elective2input ? form.elective2input : form.elective2;
    form.elective3 = form.elective3 === 'other' && form.elective3input ? form.elective3input : form.elective3;
		this.props.infoSubmit(form).then(
			(res) => {
				if (res) {
					// console.log("success")
				this.setState({loading:false, errormessage:null});
				this.props.formSubmit();
			} else {
			
				this.setState({ loading: false, errormessage: "Something wrong happened, please try again later."});
			}
		},
		(err) => {
			// console.log("error")
			this.setState({ loading: false, errormessage: "Something wrong happened, please try again later." });
			// this.formRef.current.resetFields();
		}
		);
        
    }

    handleElective1Change = (value) => {
      if (value === 'other') {
        this.setState({elective1Input: true});
      } else {
        this.setState({elective1Input: false});
      }
    }

    handleElective2Change = (value) => {
      if (value === 'other') {
        this.setState({elective2Input: true});
      } else {
        this.setState({elective2Input: false});
      }
    }

    handleElective3Change = (value) => {
      if (value === 'other') {
        this.setState({elective3Input: true});
      } else {
        this.setState({elective3Input: false});
      }
    }


    render(){

        const{infoPageData, elective1Input, elective2Input, elective3Input}=this.state;
       
        return(
            <div className="formContainer">
							<div className="questionImageContainer inforBgColor">
								<img src= {infoImage} className="questionImage"></img>
								<h1>{infoPageData[this.props.language].info.title}</h1>
							</div>
							<div className="questionFormContainer">
								{/* '${infoData}' */}
								<Form onFinish= {this.actFormSubmit}  name="infoForm" validateMessages="Field is required!">
								<div className="infoform">
									{/* <div className="formdiv"> */}
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["school"]["label"]}</div>
											<div className="staticItem longItem">{infoPageData[this.props.language]["info"]["questions"]["school"]["data"]}</div>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["year"]["label"]}</div>
											<div className="staticItem longItem">{infoPageData[this.props.language]["info"]["questions"]["year"]["data"]}</div>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["form"]["label"]}</div>
											<div className="staticItem longItem">{infoPageData[this.props.language]["info"]["questions"]["form"]["data"]}</div>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["age"]["label"]}</div>
											<Form.Item name="age"  
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												<Input className="shortItem" type="number" min={0} max={100}/>
											</Form.Item>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["chName"]["label"]}</div>
											<Form.Item  name="nameChinese"
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												<Input className="longItem" />
											</Form.Item>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["engName"]["label"]}</div>
											<Form.Item  name="nameEnglish"
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												<Input className="longItem" />
											</Form.Item>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["classNum"]["label"]}</div>
											<Form.Item  name="classNumber"
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]} >
												<Input className="shortItem" type="number" min={1} max={100}/>
											</Form.Item>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["gender"]["label"]}</div>
											<Form.Item  name="gender" 
										
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												  {/* <Form.Item noStyle> */}
												<Select allowClear className="questionSelector" onChange={this.handleChange} >
														{
                                                            (this.props.infoData)?
                                                            this.props.infoData["results"].map(
																(option, index) => {
																	if(option.type=="gender") return <Select.Option key={index} value={option["option_en"]} >{option["option_"+this.props.language]}</Select.Option>
																}
                                                            )
                                                            : null
														}
												</Select>
												{/* </Form.Item> */}
											</Form.Item>
										</div>
									{/* </div> */}
									<div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["selectiveSubject1"]["label"]}</div>
											<Form.Item  name="elective1" 
										
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												  {/* <Form.Item noStyle> */}
												<Select allowClear className="questionSelector" onChange={this.handleElective1Change} >
														{
                                                            (this.props.infoData)?
                                                            this.props.infoData["results"].map(
																(option, index) => {
																	// console.log("e1",option)
																	if(option.type=="elective") return <Select.Option key={index} value={option["_id"]} >{option["option_"+this.props.language]}</Select.Option>
																}
                                                            ).concat(<Select.Option key="other" value="other">{this.props.language === 'en' ? 'Other' : '其他'}</Select.Option>)
                                                            : null
														}
												</Select>
												{/* </Form.Item> */}
											</Form.Item>
										</div>
                    {
                      elective1Input &&
                      <div className="formItem">
                        <Form.Item  name="elective1input" 
                        rules={[
                          {
                            required: true,
                            message:"Field is required!"
                          },
                          ]}>
                          <Input className="shortItem"></Input>
                        </Form.Item>
                      </div>
                    }
										<div className="formItem">
											<Form.Item  name="elective2"
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]} 
											>
												<Select  allowClear className="questionSelector" onChange={this.handleElective2Change}>
														{
															(this.props.infoData)?
                                                            this.props.infoData["results"].map(
																(option, index) => {
																	if(option.type=="elective") return <Select.Option key={index} value={option["_id"]} >{option["option_"+this.props.language]}</Select.Option> 
																}
															).concat(<Select.Option key="other" value="other">{this.props.language === 'en' ? 'Other' : '其他'}</Select.Option>)
															:null
														}
												</Select>
											</Form.Item>
										</div>
                    {
                      elective2Input &&
                      <div className="formItem">
                        <Form.Item  name="elective2input" 
                        rules={[
                          {
                            required: true,
                            message:"Field is required!"
                          },
                          ]}>
                          <Input className="shortItem"></Input>
                        </Form.Item>
                      </div>
                    }
										<div className="formItem">
											<Form.Item  name="elective3"
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}
											>
												<Select  allowClear className="questionSelector" onChange={this.handleElective3Change}>
														{
															(this.props.infoData)?
                                                            this.props.infoData["results"].map(
																(option, index) => {
																	if(option.type=="elective") return <Select.Option key={index} value={option["_id"]} >{option["option_"+this.props.language]}</Select.Option>
																}
															).concat(<Select.Option key="other" value="other">{this.props.language === 'en' ? 'Other' : '其他'}</Select.Option>)
															:null
														}
												</Select>
											</Form.Item>
										</div>
                    {
                      elective3Input &&
                      <div className="formItem">
                        <Form.Item  name="elective3input" 
                        rules={[
                          {
                            required: true,
                            message:"Field is required!"
                          },
                          ]}>
                          <Input className="shortItem"></Input>
                        </Form.Item>
                      </div>
                    }
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["fatherLv"]["label"]}</div>
											<Form.Item  name="educationFather" 
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												<Select  allowClear className="questionSelector">
														{
															(this.props.infoData)?
                                                            this.props.infoData["results"].map(
																(option, index) => {
																	 if(option.type=="education") return <Select.Option key={index} value={option["_id"]} >{option["option_"+this.props.language]}</Select.Option> 
																}
															)
															:null
														}
												</Select>
											</Form.Item>
										</div>
										<div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["motherLv"]["label"]}</div>
											<Form.Item  name="educationMother" 
											rules={[
												{
												  required: true,
												  message:"Field is required!"
												},
											  ]}>
												<Select allowClear className="questionSelector">
														{
															(this.props.infoData)?
                                                            this.props.infoData["results"].map(
																(option, index) => {
																	if(option.type=="education") return <Select.Option key={index} value={option["_id"]} >{option["option_"+this.props.language]}</Select.Option> 
																}
															)
															:null
														}
												</Select>
											</Form.Item>
										</div>
										{/* <div className="formItem">
											<div className="formtitle">{infoPageData[this.props.language]["info"]["questions"]["religion"]["label"]}</div>
											<Form.Item  name={infoPageData[this.props.language]["info"]["questions"]["religion"]["label"]} >
												<Select placeholder={infoPageData[this.props.language]["info"]["questions"]["religion"]["data"][0]} allowClear className="questionSelector">
														{
															infoPageData[this.props.language]["info"]["questions"]["religion"]["data"].map(
																(option, index) => {
																	return <Select.Option key={index} value={option} >{option}</Select.Option>
																}
															)
														}
												</Select>
											</Form.Item>
										</div> */}
									{/* <div glutter={24} className="form">
									{Object.keys(infoPageData[this.props.language].info.questions).map(
									</div>*/}
									<div className="submitBtnContainer">
										<Form.Item>
										<Button type="primary" htmlType="submit" className="questionsSubmitBtn">{infoPageData[this.props.language].submit}</Button>
										</Form.Item>
									</div>
									</div>
								</Form> 
							</div>
						</div>
        )
    }

}
const mapStateToProps = state => ({
    infoData: state.questions.infoData,
    language: state.mainpage.language,
	userProfile: state.user.userProfile
});

const mapDispatchToProps = dispatch =>
bindActionCreators(
	{
		infoList,infoSubmit
	},
	dispatch
);

//mapStateToProps should be passed as the 1st argument to connect
export default connect(mapStateToProps, mapDispatchToProps) (InfoForm);